module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1300.377a4db9.svg";